import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

const previewSearchSchema = z.object({
    organisationId: z.string().uuid(),
    sftpPath: z.string().min(1),
    diaryId: z.string().uuid().optional(),
    patientId: z.string().uuid().optional(),
    title: z.string().optional(),
    organisationName: z.string().optional(),
});

export const Route = createFileRoute("/_app/admin/sftp/preview")({
    validateSearch: (search) => previewSearchSchema.parse(search),
    beforeLoad: ({ search }) => {
        throw redirect({ to: "/developer/sftp/preview", search, replace: true });
    },
});
